// src/components/pages/Movimento/list/mrt/getColumnsByOperacao.js
import moment from 'moment';
import { getNestedValue } from '../../../../helpers/mrt';

export function getColumnsByOperacao(params) {
    const { operacao, parceiroTipo, optionsSituacao, optionsGrupo, optionsEmpresa } = params;

    //rotina para definir as colunas da grid conforme a operação
    const sigla = operacao.sigla;
    const descricao = operacao.descricao;
    if (sigla === 'LIM') {
        return [
            {
                id: 'Movimento',
                header: `${descricao} - ${sigla}`,
                columns: [
                    {
                        accessorKey: 'data',
                        header: 'Data',
                        accessorFn: (row) => new Date(row.data),
                        Cell: ({ row }) => <span>{moment.utc(row.original.data).format('DD/MM/YYYY')}</span>,
                        filterVariant: 'date',
                        sortingFn: 'date',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: { align: 'center' },
                    },
                    {
                        accessorKey: 'Parceiro.descricao',
                        header: parceiroTipo,
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'movimentoItems.Produto.descricao',
                        id: 'Produto.descricao',
                        header: 'Imóvel',
                        accessorFn: (row) => {
                            if (!Array.isArray(row.movimentoItems) || row.movimentoItems.length === 0) {
                                return '';
                            }
                            return row.movimentoItems[0].Produto?.descricao || '';
                        },
                    },
                    {
                        accessorKey: 'Situacao.descricao',
                        header: 'Situação',
                        filterFn: 'equals',
                        filterVariant: 'select',
                        filterSelectOptions: optionsSituacao,
                    },
                    {
                        accessorKey: 'movimentoItems.valorUnitario',
                        id: 'movimentoItems.valorUnitario',
                        header: 'Aluguel',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) => {
                            const total = (row.movimentoItems || []).reduce((sum, item) => {
                                const val = parseFloat(item.valorUnitario);
                                return sum + (isNaN(val) ? 0 : val);
                            }, 0);
                            return total === 0
                                ? ''
                                : total.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                  });
                        },
                    },
                    {
                        accessorKey: 'movimentoItems.quantidade',
                        id: 'movimentoItems.quantidade',
                        header: 'Meses',
                        muiTableBodyCellProps: { align: 'center' },
                        accessorFn: (row) => {
                            const total = (row.movimentoItems || []).reduce((sum, item) => {
                                const val = parseFloat(item.quantidade);
                                return sum + (isNaN(val) ? 0 : val);
                            }, 0);
                            return total || '';
                        },
                    },
                    {
                        accessorKey: 'movimentoItems.valorTotal',
                        id: 'movimentoItems.valorTotal',
                        header: 'Total',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) => {
                            const total = (row.movimentoItems || []).reduce((sum, item) => {
                                const val = parseFloat(item.valorTotal);
                                return sum + (isNaN(val) ? 0 : val);
                            }, 0);
                            return total === 0
                                ? ''
                                : total.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                  });
                        },
                    },
                    {
                        accessorKey: 'saida',
                        id: 'saida',
                        header: 'Data Saída',
                        accessorFn: (row) => new Date(row.saida),
                        Cell: ({ row }) => <span>{moment.utc(row.original.saida).format('DD/MM/YYYY')}</span>,
                        filterVariant: 'date',
                        sortingFn: 'date',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: { align: 'center' },
                        muiTableHeadCellFilterTextFieldProps: {
                            type: 'date',
                            InputLabelProps: {
                                shrink: true,
                            },
                            sx: { minWidth: '200px' },
                        },
                    },
                    {
                        accessorKey: 'transformado',
                        header: 'Transformado',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.transformado;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'Empresa.nomeFantasia',
                        header: 'Empresa',
                    },
                ],
            },
        ];
    } else if (sigla === 'REST') {
        // Operações comuns
        return [
            {
                id: 'Movimento',
                header: `${descricao} - ${sigla}`,
                columns: [
                    {
                        accessorKey: 'data',
                        header: 'Data',
                        accessorFn: (row) => new Date(row.data),
                        Cell: ({ row }) => <span>{moment.utc(row.original.data).format('DD/MM/YYYY')}</span>,
                        filterVariant: 'date',
                        sortingFn: 'date',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: { align: 'center' },
                    },
                    {
                        accessorKey: 'contador',
                        header: 'Contador',
                    },
                    {
                        accessorKey: 'Situacao.descricao',
                        header: 'Situação',
                        filterFn: 'equals',
                        filterVariant: 'select',
                        filterSelectOptions: optionsSituacao,
                    },
                    {
                        accessorKey: 'movimentoItems.valorTotal',
                        id: 'movimentoItems.valorTotal',
                        header: 'Total',
                        muiTableBodyCellProps: { align: 'right' },
                        accessorFn: (row) => {
                            const total = (row.movimentoItems || []).reduce((sum, item) => {
                                const val = parseFloat(item.valorTotal);
                                return sum + (isNaN(val) ? 0 : val);
                            }, 0);
                            return total === 0
                                ? ''
                                : total.toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                  });
                        },
                    },
                    {
                        accessorKey: 'Parceiro.descricao',
                        header: parceiroTipo,
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'numero',
                        header: 'Número',
                    },
                    {
                        accessorKey: 'Empresa.nomeFantasia',
                        header: 'Empresa',
                        filterVariant: 'select',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: optionsEmpresa,
                    },
                    {
                        accessorKey: 'transformado',
                        header: 'Transformado',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.transformado;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'custo',
                        header: 'Custo',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.custo;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'custoFilial',
                        header: 'Custo Filial',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.custoFilial;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'createdAt', // Garanta que este é o nome exato da propriedade no seu objeto
                        header: 'Data Registro',
                        // O accessorFn deve retornar a data do mesmo campo (createdAt) como um objeto Date para o filtro funcionar
                        accessorFn: (row) => (row.createdAt ? new Date(row.createdAt) : null),
                        // Exibição formatada com Moment.js
                        Cell: ({ cell }) =>
                            cell.getValue() ? <span>{moment(cell.getValue()).format('DD/MM/YYYY HH:mm')}</span> : null,
                        filterVariant: 'datetime',
                        sortingFn: 'date',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: { align: 'center' },
                    },
                ],
            },
        ];
    } else if (sigla === 'XML') {
        return [
            {
                id: 'Movimento',
                header: `${descricao} - ${sigla}`,
                columns: [
                    {
                        accessorKey: 'data',
                        header: 'Data',
                        accessorFn: (row) => new Date(row.data),
                        Cell: ({ row }) => <span>{moment.utc(row.original.data).format('DD/MM/YYYY')}</span>,
                        filterVariant: 'date',
                        sortingFn: 'date',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: { align: 'center' },
                    },
                    {
                        accessorKey: 'numero',
                        header: 'Número',
                    },
                    {
                        accessorKey: 'Situacao.descricao',
                        header: 'Situação',
                        filterFn: 'equals',
                        filterVariant: 'select',
                        filterSelectOptions: optionsSituacao,
                    },
                    {
                        accessorKey: 'Parceiro.descricao',
                        header: parceiroTipo,
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'Parceiro.nomeFantasia',
                        header: 'Nome Fantasia',
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'natOp',
                        header: 'Natureza Operação',
                    },
                    {
                        accessorKey: 'transformado',
                        header: 'Transformado',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.transformado;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'Empresa.nomeFantasia',
                        header: 'Empresa',
                        filterVariant: 'select',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: optionsEmpresa,
                    },
                ],
            },
        ];
    } else if (sigla === 'PDV') {
        return [
            {
                id: 'Movimento',
                header: `${descricao} - ${sigla}`,
                columns: [
                    {
                        id: 'data',
                        header: 'Data',
                        accessorFn: (row) => new Date(row.data),
                        Cell: ({ row }) => <span>{moment.utc(row.original.data).format('DD/MM/YYYY')}</span>,
                        filterVariant: 'date',
                        sortingFn: 'date',
                        columnFilterModeOptions: [
                            'fuzzy',
                            'equals',
                            'between',
                            'betweenInclusive',
                            'greaterThanOrEqualTo',
                            'lessThanOrEqualTo',
                        ],
                        muiTableBodyCellProps: { align: 'center' },
                    },
                    {
                        accessorKey: 'contador',
                        header: 'Contador',
                    },
                    {
                        id: 'Situacao.descricao',
                        accessorFn: (row) => getNestedValue(row, 'Situacao.descricao'),
                        header: 'Situação',
                        filterFn: 'equals',
                        filterVariant: 'select',
                        filterSelectOptions: optionsSituacao,
                    },
                    {
                        id: 'Parceiro.descricao',
                        accessorFn: (row) => getNestedValue(row, 'Parceiro.descricao'),
                        header: parceiroTipo,
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        id: 'Parceiro.nomeFantasia',
                        accessorFn: (row) => getNestedValue(row, 'Parceiro.nomeFantasia'),
                        header: 'Nome Fantasia',
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        id: 'movimentoItems.Produto.Grupo.descricao',
                        accessorFn: (row) => getNestedValue(row, 'movimentoItems.Produto.Grupo.descricao'),
                        header: 'Grupo',
                        filterFn: 'equals',
                        filterVariant: 'select',
                        filterSelectOptions: optionsGrupo,
                    },
                    {
                        accessorKey: 'transformado',
                        header: 'Transformado',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original.transformado;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'Parceiro.parceiro',
                        header: 'Parceiro',
                        type: 'boolean',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        Cell: ({ row }) => {
                            const value = row.original?.Parceiro?.parceiro;
                            return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                        },
                    },
                    {
                        accessorKey: 'Empresa.nomeFantasia',
                        header: 'Empresa',
                        filterVariant: 'select',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: optionsEmpresa,
                    },
                ],
            },
        ];
    }

    // Operações comuns
    return [
        {
            id: 'Movimento',
            header: `${descricao} - ${sigla}`,
            columns: [
                {
                    id: 'data',
                    header: 'Data',
                    accessorFn: (row) => new Date(row.data),
                    Cell: ({ row }) => <span>{moment.utc(row.original.data).format('DD/MM/YYYY')}</span>,
                    filterVariant: 'date',
                    sortingFn: 'date',
                    columnFilterModeOptions: [
                        'fuzzy',
                        'equals',
                        'between',
                        'betweenInclusive',
                        'greaterThanOrEqualTo',
                        'lessThanOrEqualTo',
                    ],
                    muiTableBodyCellProps: { align: 'center' },
                },
                {
                    accessorKey: 'contador',
                    header: 'Contador',
                },
                {
                    accessorKey: 'numero',
                    header: 'Número',
                },
                {
                    id: 'Situacao.descricao',
                    accessorFn: (row) => getNestedValue(row, 'Situacao.descricao'),
                    header: 'Situação',
                    filterFn: 'equals',
                    filterVariant: 'select',
                    filterSelectOptions: optionsSituacao,
                },
                {
                    id: 'Parceiro.descricao',
                    accessorFn: (row) => getNestedValue(row, 'Parceiro.descricao'),
                    header: parceiroTipo,
                    muiTableBodyCellProps: ({ row, cell }) => ({
                        onClick: () => {
                            console.info(row.original);
                        },
                    }),
                },
                {
                    id: 'Parceiro.nomeFantasia',
                    accessorFn: (row) => getNestedValue(row, 'Parceiro.nomeFantasia'),
                    header: 'Nome Fantasia',
                    muiTableBodyCellProps: ({ row, cell }) => ({
                        onClick: () => {
                            console.info(row.original);
                        },
                    }),
                },
                {
                    id: 'movimentoItems.Produto.Grupo.descricao',
                    accessorFn: (row) => getNestedValue(row, 'movimentoItems.Produto.Grupo.descricao'),
                    header: 'Grupo',
                    filterFn: 'equals',
                    filterVariant: 'select',
                    filterSelectOptions: optionsGrupo,
                },
                {
                    accessorKey: 'transformado',
                    header: 'Transformado',
                    type: 'boolean',
                    columnFilterModeOptions: ['equals'],
                    filterSelectOptions: [
                        { label: 'Todos', value: '' },
                        { label: 'Sim', value: '1' },
                        { label: 'Não', value: '0' },
                    ],
                    filterVariant: 'select',
                    Cell: ({ row }) => {
                        const value = row.original.transformado;
                        return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                    },
                },
                {
                    accessorKey: 'Parceiro.parceiro',
                    header: 'Parceiro',
                    type: 'boolean',
                    columnFilterModeOptions: ['equals'],
                    filterSelectOptions: [
                        { label: 'Todos', value: '' },
                        { label: 'Sim', value: '1' },
                        { label: 'Não', value: '0' },
                    ],
                    filterVariant: 'select',
                    Cell: ({ row }) => {
                        const value = row.original?.Parceiro?.parceiro;
                        return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                    },
                },
                {
                    accessorKey: 'Empresa.nomeFantasia',
                    header: 'Empresa',
                    filterVariant: 'select',
                    columnFilterModeOptions: ['equals'],
                    filterSelectOptions: optionsEmpresa,
                },
            ],
        },
    ];
}
